import { Admin, PasswordRequirements } from './admin';
import { DateTime } from 'luxon';

export namespace AdminParsers {
  export class AdminJson {
    adminId!: number;
    adminUsername!: string;
    adminFullName!: string;
    adminEmail!: string;
    adminIsSuperAdmin!: number;
    deletedAt?: string;
  }

  export function toAdmin(input: AdminJson): Admin {
    return {
      ...input,
      deletedAt: input.deletedAt ? DateTime.fromISO(input.deletedAt) : undefined,
    };
  }

  export type PasswordRequirementsJson = {
    readonly id: string;
    readonly lowercaseCharacters: number;
    readonly uppercaseCharacters: number;
    readonly numericCharacters: number;
    readonly specialCharacters: number;
    readonly minimumLength: number;
    readonly createdBy: number;
    readonly createdAt: string;
  };

  export function toPasswordRequirements(input: PasswordRequirementsJson): PasswordRequirements {
    return {
      id: input.id,
      lowercaseCharacters: input.lowercaseCharacters,
      uppercaseCharacters: input.uppercaseCharacters,
      numericCharacters: input.numericCharacters,
      specialCharacters: input.specialCharacters,
      minimumLength: input.minimumLength,
      createdBy: input.createdBy,
      createdAt: DateTime.fromISO(input.createdAt, { setZone: true }),
    };
  }
}
